import React from "react";
const PayslipTop = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          justifyItems: "center",
          alignItems: "center",
          width: "100%",
          padding: "0 7px",
        }}
      >
        <div
          style={{
            border: "none",
            textAlign: "center",
          }}
        >
          <div style={{ textAlign: "right" }}>
            <b
              style={{
                fontSize: "2em",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
            >
              Kryzen Biotech Private Limited
            </b>
            <p
              className="text-muted"
              style={{
                textAlign: "left",
                fontSize: "15px",
                fontWeight: 500,
              }}
            >
              M319, City Avenue, Pune-Bangalore Highway, Wakad, 411057
            </p>
          </div>
        </div>
        <div
          style={{
            border: "none",
            textAlign: "center",
          }}
        >
          <img
            width={"100px"}
            src={
              "https://res.cloudinary.com/dsmabnook/image/upload/v1757651285/kryzenLogo_v87dtw.png"
            }
            alt={"kryzen biotech"}
          />
        </div>
      </div>
    </>
  );
};

export default PayslipTop;
